import React from 'react';
import './SearchControl.css';

export interface SearchControlProps {
	searchQuery: string;
	onSearchChange: (query: string) => void;
	placeholder?: string;
}

export const SearchControl: React.FC<SearchControlProps> = ({
	searchQuery,
	onSearchChange,
	placeholder = 'Search settings...',
}) => {
	return (
		<div className="search-container">
			<div className="search-input-wrapper">
				<svg
					className="search-icon"
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
						fill="none"
					/>
					<path
						d="M10.5 10.5L14 14"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				<input
					type="text"
					className="search-input"
					placeholder={placeholder}
					value={searchQuery}
					onChange={(e) => onSearchChange(e.target.value)}
				/>
			</div>
		</div>
	);
};
